/**
 * 账号中心配置 - tokenUrl、clientId、ssoUrl、appId 配置
 */

// 线上
const configUserCenterProd = {
    appId: 'cli_a3c7b57abb62d00e', // 开放平台创建应用获取（open.feishu.cn）
    clientId: 'K4686d7d7777a5e10',
    ssoUrl: 'https://iama.haier.net', // 账号中心统一登录页
    tokenUrl: 'https://xue.hilook.com.cn/h5/v1/login/ihaier' // 集成了账号中心提供的后端服务的地址
};

// 开发/测试环境
const configUserCenterDev = {
    appId: 'cli_a3c4870b3039500e', // 开放平台创建应用获取（open.feishu.cn）
    clientId: 'K9507ed050a3284aa',
    ssoUrl: 'https://iam-test.haier.net', // 账号中心统一登录页
    tokenUrl: 'https://haixueh5-test.lanbenzi.cn:8443/h5/v1/login/ihaier' // 集成了账号中心提供的后端服务的地址
};

/**
 * 获取账号中心配置
 * @returns {object} 包含 appId、clientId、ssoUrl、tokenUrl 的配置对象
 */
export function getUserCenterConfig() {
    return process.env.NODE_ENV === "production" 
        ? configUserCenterProd 
        : configUserCenterDev;
}

/**
 * 获取账号中心 appId 配置
 * @returns {string} appId
 */
export function getUserCenterAppId() {
    return getUserCenterConfig().appId;
}

/**
 * 获取账号中心 clientId 配置
 * @returns {string} clientId
 */
export function getUserCenterClientId() {
    return getUserCenterConfig().clientId;
}

/**
 * 获取账号中心 ssoUrl 配置
 * @returns {string} ssoUrl
 */
export function getUserCenterSsoUrl() {
    return getUserCenterConfig().ssoUrl;
}

/**
 * 获取账号中心 tokenUrl 配置
 * @returns {string} tokenUrl
 */
export function getUserCenterTokenUrl() {
    return getUserCenterConfig().tokenUrl;
}

